import { Grid, Link } from "@trussworks/react-uswds";
import { ReactComponent as Hearthand } from "../../images/hearthand.svg";
import styled from "styled-components";
import { AnalyticsAction, logEvent } from "../../utils/analytics";
const Highlight = styled.div`
  background-color: #F6F9FC;  
  @media print
    {    
      display: none !important;
    }
`;
type InclusionCardProps = {
  header: string;
  cta: string;
  url: string;
};
function InclusionCard({ header, cta, url }: InclusionCardProps) {
  return (
    <Grid>
      <Highlight 
        as="div"
        className="margin-top-5">
        <div className="d-inline-flex">
          <svg viewBox="0 0 100 100" width={90}>
            <circle cx="55" cy="55" r="22.5" fill="#FFFFFF" />
            <Hearthand />
          </svg>
          <div>
            <h2 className="margin-top-2">{header}</h2>
            <Link 
             onClick={() => logEvent(AnalyticsAction.ProviderSearchInclusion)}
             href={url} 
             rel="noreferrer" 
             target="_blank" 
             variant="external">{cta}</Link>
          </div>
        </div>
      </Highlight>
      </Grid>
  );
}
export default InclusionCard;